export default __webpack_public_path__ + "static/media/summer_jobs_icon.7aed35f5.png";